import PageManagement from "./PageManagement.presenter";

export default PageManagement;
